import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Layout from "../../layouts/auth.vue";
import Loader from "@/components/widgets/loader.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { UserRegistrationModel } from "@/store/models/userRegistration/userRegistration";
import UserRegistrationModule from "@/store/modules/userRegistration.module";
let SystemoneRegistration = /** @class */ (() => {
    let SystemoneRegistration = class SystemoneRegistration extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.pageIsLoading = true;
            this.userRegistration = new UserRegistrationModel();
        }
        //Computed
        get TimeZone() {
            return UserRegistrationModule.Timezones;
        }
        //Methods
        saveUserRegistration() {
            this.validate("userRegistrationObserver").then((response) => {
                if (response) {
                    this.pageIsLoading = true;
                    UserRegistrationModule.SaveUserRegistration(this.userRegistration).then((res) => {
                        if (res) {
                            if (res.warningMessages.length > 0) {
                                this.$bvModal.show("register_error");
                            }
                            else {
                                this.$router.push({
                                    name: "UserRegistrationSuccess",
                                });
                            }
                        }
                        this.pageIsLoading = false;
                    });
                }
            });
        }
        closeRegistration() {
            this.$bvModal.hide("register_error");
            this.$router.push({
                name: "default",
            });
        }
        created() {
            UserRegistrationModule.GetTimezoneForUserRegistration().then((res) => {
                if (res) {
                    this.pageIsLoading = false;
                }
            });
        }
    };
    SystemoneRegistration = __decorate([
        Component({
            name: "SystemoneRegistration",
            components: {
                Layout,
                PageHeader,
                Loader,
            },
        })
    ], SystemoneRegistration);
    return SystemoneRegistration;
})();
export default SystemoneRegistration;
